module.exports = __webpack_public_path__ + "static/media/10.7d30e963.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/detail/ngk/10.png
// module id = 675
// module chunks = 0